import type { AuthUser } from '~~/shared/types/auth-provider';

export const useAuthUser = () => useState<AuthUser | null>('auth-user', () => null);

export function useAuth() {
    const user = useAuthUser();

    return {
        user: readonly(user),
        isAuthenticated: computed(() => Boolean(user.value)),

        async signOut() {
            user.value = null;
            const cookie = useCookie('__dds_demo_user');
            const roleCookie = useCookie('__dds_demo_role');
            cookie.value = null;
            roleCookie.value = null;
        }
    };
}
